module.exports = __webpack_public_path__ + "img/icon_3.9968038a.svg";